import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/Next_logo.svg'


const _hoisted_1 = { class: "fixed z-10 inset-0 bg-next-light-gray" }
const _hoisted_2 = { class: "flex items-center justify-center h-screen p-4 overflow-y-auto" }
const _hoisted_3 = { class: "bg-white p-6 border-2 border-next-neu" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-col items-center m-3 text-center text-2xl" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "flex flex-col items-center m-3 text-center text-2xl" }
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex justify-center m-8" }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.env.googleLoginEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "p-2" }, "Google", -1)),
                  _createElementVNode("a", { href: _ctx.googleUrl }, _cache[0] || (_cache[0] = [
                    _createElementVNode("i", { class: "fab fa-google py-2 px-8 bg-next-orange text-white" }, null, -1)
                  ]), 8, _hoisted_7)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "p-2" }, "Microsoft", -1)),
              _createElementVNode("a", { href: _ctx.microsoftUrl }, _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fab fa-microsoft py-2 px-8 bg-next-orange text-white" }, null, -1)
              ]), 8, _hoisted_10)
            ])
          ])
        ])
      ])
    ])
  ]))
}